import * as React from 'react'
import {
  EraserIcon,
  MagicWand02Icon,
  DropperIcon,
  Contrast02Icon,
} from '@repo/studio-design-system-ui-icons/editor'
import { ColorsIcon, CameraPlusIcon } from '@repo/studio-design-system-ui-icons/images'
import { UserSquareIcon } from '@repo/studio-design-system-ui-icons/users'
import { FontGenerateIcon } from '@repo/studio-design-system-ui-icons/general'
// oxlint-disable-next-line cf-web/banned-imports
import { Sparkles } from '../components/lucide-icons'
import {
  FlowIcon,
  StudioIcon,
  TransferIcon,
  VectorizerIcon,
  BackgroundRemoverIcon,
  FontGeneratorIcon,
  UpscalerIcon,
  FileConverterIcon,
  ImageCompressorIcon,
  LogoCreatorIcon,
  DesignReviewerIcon,
  AIImageEditorIcon,
  AIQuoteGeneratorIcon,
  MusicNotePlusIcon,
  WavesIcon,
  Brush01Icon,
  Perspective02Icon,
  ImageRightIcon,
  AIChipImageIcon,
  CodepenIcon,
  DataIcon,
  Cat01Icon,
  Certificate02Icon,
  Pencil01Icon,
  ExpandIcon,
  Film02Icon,
  HeartsIcon,
  PresentationChartIcon,
  Users01Icon,
  CubeOutlineIcon,
  EffectWaveIcon,
  PenToolIcon,
  Globe02Icon,
  PackageIcon,
  Stars01Icon,
  // oxlint-disable-next-line cf-web/banned-imports
} from 'primitives/icons'

/**
 * Maps tool translation keys to their icon components.
 * Single source of truth — consumed by both Studio's app-switch-bar
 * and the homepage navigation (cf-menu).
 */
export const TOOL_ICONS: Record<string, React.JSX.Element> = {
  TOOL_TYPE_IMAGE_EDITOR: <AIImageEditorIcon />,
  TOOL_TYPE_FLOW: <FlowIcon />,
  TOOL_TYPE_AI_PHOTO_STYLES: <AIChipImageIcon />,
  TOOL_TYPE_AI_MOCKUP_GENERATOR: <MagicWand02Icon />,
  TOOL_TYPE_VECTORIZER: <VectorizerIcon />,
  TOOL_TYPE_AISVG_GENERATOR: <PenToolIcon />,
  TOOL_TYPE_UPSCALER: <UpscalerIcon />,
  TOOL_TYPE_BG_REMOVER: <BackgroundRemoverIcon />,
  TOOL_TYPE_PEOPLE_REMOVER_FROM_BACKGROUND: <EraserIcon />,
  TOOL_TYPE_LOGO_GENERATOR: <LogoCreatorIcon />,
  TOOL_TYPE_QUOTE_GENERATOR: <AIQuoteGeneratorIcon />,
  TOOL_TYPE_COLLAGE_MAKER: <Perspective02Icon />,
  TOOL_TYPE_DESIGN_REVIEWER: <DesignReviewerIcon />,
  TOOL_TYPE_FONT_GENERATOR: <FontGeneratorIcon />,
  TOOL_TYPE_AI_MUSIC_GENERATOR: <MusicNotePlusIcon />,
  TOOL_TYPE_VIDEO_GENERATOR: <Film02Icon />,
  TOOL_TYPE_VIDEO_UPSCALER: <ExpandIcon />,
  TOOL_TYPE_IMAGE_ALIVE: <UserSquareIcon />,
  TOOL_TYPE_AD_CAMPAIGN_GENERATOR: <Stars01Icon />,
  TOOL_TYPE_PRODUCT_MANAGER: <PackageIcon />,
  TOOL_TYPE_SOUND_GENERATOR: <WavesIcon />,
  TOOL_TYPE_SPEECH_GENERATOR: <Brush01Icon />,
  TOOL_TYPE_AI_WATERMARK_REMOVER: <EraserIcon />,
  TOOL_TYPE_FILE_CONVERTER: <FileConverterIcon />,
  TOOL_TYPE_IMAGE_COMPRESSOR: <ImageCompressorIcon />,
  TOOL_TYPE_TRANSFERS: <TransferIcon />,
  TOOL_TYPE_STUDIO_DESIGNER: <StudioIcon />,
  TOOL_TYPE_LUMO: <Sparkles />,
  TOOL_TYPE_THREED_MODEL_VIEWER: <CodepenIcon />,
  TOOL_TYPE_THREED_SCULPT: <EffectWaveIcon />,
  TOOL_TYPE_SPLAT_GENERATOR: <Globe02Icon />,
  TOOL_TYPE_IMAGE_RESIZER: <ImageRightIcon />,
  TOOL_TYPE_THREED_PRINT_GENERATOR: <DataIcon />,
  TOOL_TYPE_MESH_GENERATOR: <CubeOutlineIcon />,
  TOOL_TYPE_MOMENTS: <Certificate02Icon />,
  TOOL_TYPE_DOODLE_PET_GENERATOR: <Cat01Icon />,
  TOOL_TYPE_COLOR_PALETTE_PICKER: <ColorsIcon />,
  TOOL_TYPE_AI_COLORING_PAGE_MAKER: <Pencil01Icon />,
  TOOL_TYPE_WEDDING_INVITE_GENERATOR: <HeartsIcon />,
  TOOL_TYPE_ETSY_COACH: <PresentationChartIcon />,
  TOOL_TYPE_TOON_FAMILY_BUILDER: <Users01Icon />,
  TOOL_TYPE_CAMERA_ANGLE: <CameraPlusIcon />,
  TOOL_TYPE_SUBTITLE_GENERATOR: <FontGenerateIcon />,
  TOOL_TYPE_COLOR_CONVERTER: <DropperIcon />,
  TOOL_TYPE_CONTRAST_CHECKER: <Contrast02Icon />,
}
